export const customerReviews = [
    {
      "name": "Arjun",
      "location": "Guntur AP",
      "message": "Great service and genuine medicines, and with low prices with great discounts, very trustworthy pharmacy."
    },
    {
      "name": "Suresh Kumar",
      "location": "Vijayawada (Krishna) AP",
      "message": "Helpful staff and clear information about every product."
    },
    {
      "name": "Rahul Chowdary",
      "location": "Visakhapatnam AP",
      "message": "Highly satisfied with the quality and reliability of the pharmacy"
    },
    {
      "name": "Vamsi Krishna",
      "location": "Nellore, AP",
      "message": "Clean, organized, and very supportive team—excellent experience."
    },
    {
      "name": "Sai Teja",
      "location": "Kurnool, AP",
      "message": "Affordable prices and detailed guidance for all health needs."
    },
    {
      "name": "Harika Rani",
      "location": "Tirupati (Chittoor), AP",
      "message": "Very professional and friendly, I always trust their products. Thank you AGAPE Health Care"
    },
    {
      "name": "Deepika M",
      "location": "Rajahmundry (East Godavari), AP",
      "message": "Clear explanations and safe products, highly recommended."
    },
    {
      "name": "Naga Sravani",
      "location": "Anantapur, AP",
      "message": "Their team is polite and provides correct health information."
    },
    {
      "name": "Sushmitha Reddy",
      "location": "Kadapa (YSR Kadapa), AP",
      "message": "Great experience, everything is well-organized and dependable."
    },
    {
      "name": "Meghana Devi",
      "location": "Ongole (Prakasam)",
      "message": "Quality products with quick assistance—very impressed with the service."
    }
];
